import React from 'react';
import { useSelector } from 'react-redux';
import { hasMoreProfile as hasMoreProfileSelector } from 'app/reducer/profileRedux';

import { List } from 'app/seedly-component-library';
import UserPassport from 'app/components/profile/UserPassport';

const ProfileList = props => {
  const { profileIds, handleLoadMoreProfile } = props;

  // Selectors
  const profileById = useSelector(state => state.profile.byId);
  const hasMoreProfile = useSelector(hasMoreProfileSelector);

  if (!profileIds || profileIds.length === 0) {
    return (
      <div className="flex items-center justify-center w-full h-16 bg-white">
        <p className="text-neutral-500 font-bold text-base">
          No profiles found.
        </p>
      </div>
    );
  }

  return (
    <>
      <List
        alignment="horizontal"
        dataSource={profileIds.map(id => {
          const profile = profileById[id];
          return (
            <div
              className="h-fit w-full lg:w-[300px] bg-white rounded p-4 mr-0 lg:mr-2.5 mb-1 lg:mb-2.5"
              key={id}
            >
              <UserPassport profile={profile} />
            </div>
          );
        })}
      />
      {hasMoreProfile && handleLoadMoreProfile && (
        <div className="flex items-center justify-center lg:w-[615px] w-full">
          <span className="cursor-pointer" onClick={handleLoadMoreProfile}>
            Load More Profiles
          </span>
        </div>
      )}
    </>
  );
};

export default ProfileList;
